import { render } from "./SavingTable.vue?vue&type=template&id=a45eacc8"
import script from "./SavingTable.vue?vue&type=script&lang=js"
export * from "./SavingTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__